import React, { useMemo } from 'react'
import { Helmet } from 'react-helmet'
import { Header, Icon, Segment } from 'semantic-ui-react'

import { isDrayNowHost } from './lib/config/multitenancy.js'
import { useTenantStore } from './stores/tenantStore.js'

import Connection from './components/Connection/Connection.jsx'
import EnvironmentBanner from './components/EnvironmentBanner/EnvironmentBanner.jsx'
import ErrorBoundary from './components/ErrorBoundary/ErrorBoundary.jsx'
import SupportButton from './components/Support/SupportButton/SupportButton.jsx'
import ToastProvider from './components/Toast/ToastProvider.jsx'
import UpdateNotifier from './components/UpdateNotifier/UpdateNotifier.jsx'
import { AppRoutes } from './components/AppRoutes/AppRoutes.jsx'
import { AuthGate } from './layouts/AuthGate.jsx'

const App = () => {
  const loadError = useTenantStore((s) => s.loadError)
  const appName = useMemo(() => (isDrayNowHost() ? 'DrayNow' : 'ModalView'), [])

  if (loadError) {
    return (
      <>
        <Helmet titleTemplate={`%s - ${appName}`} />
        <Segment placeholder>
          <Header>
            <Icon name='exclamation circle' size='small' />
            Oops! Something went wrong.
          </Header>
          <p>Check your Internet connection and the URL in the address bar.</p>
        </Segment>
      </>
    )
  }

  return (
    <ToastProvider>
      <EnvironmentBanner />
      <Helmet titleTemplate={`%s - ${appName}`} />
      <Connection />
      <UpdateNotifier />
      <SupportButton />
      <ErrorBoundary>
        <AuthGate>
          <AppRoutes />
        </AuthGate>
      </ErrorBoundary>
    </ToastProvider>
  )
}

export default App
